/**
 * Vestolio Branding Assets
 *
 * Central location for all branding image paths.
 * Images are stored in /public/assets/branding/ and served statically.
 */

/** Full Vestolio logo (horizontal, color) */
export const VESTOLIO_FULL_LOGO = '/assets/branding/vestolio-logo-full.png'

/** Vestolio icon/mark only */
export const VESTOLIO_ICON_LOGO = '/assets/branding/vestolio-icon.png'

/** Oli AI avatar/icon (colored, for light backgrounds) */
export const OLI_AI_ICON = '/assets/branding/oli-ai.png'

/** Oli AI icon (white, for dark backgrounds) */
export const OLI_AI_ICON_WHITE = '/assets/branding/oli-ai-white.png'
